import { useState } from "react";
import { Check, Copy, Link2, Mail, MessageCircle, Share2 } from "lucide-react";
import { toast } from "sonner";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function ShareButton({ title, text, shareUrl, className = "", testId = "yacht-share" }) {
  const [copied, setCopied] = useState(false);
  const url = shareUrl || (typeof window !== "undefined" ? window.location.href : "");
  const message = `${text}\n${url}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copied to clipboard.");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Could not copy the link.");
    }
  };

  const nativeShare = async () => {
    try {
      await navigator.share({ title, text, url });
    } catch (err) {
      if (err?.name !== "AbortError") toast.error("Sharing was not completed.");
    }
  };

  const itemClass = "flex cursor-pointer items-center gap-3 rounded-none px-3 py-2.5 text-[11px] uppercase tracking-[0.25em] text-navy-ink focus:bg-gold/10 focus:text-gold";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid={`${testId}-button`}
          className={`inline-flex items-center gap-2 border border-navy-ink/20 px-7 py-4 text-[11px] uppercase tracking-[0.3em] text-navy-ink transition-colors duration-300 hover:border-gold hover:text-gold ${className}`}
        >
          <Share2 size={14} /> Share
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60 rounded-none border-navy-ink/10 bg-navy p-1 shadow-xl" data-testid={`${testId}-menu`}>
        <DropdownMenuItem onSelect={copy} className={itemClass} data-testid={`${testId}-copy`}>
          {copied ? <Check size={14} className="text-gold" /> : <Copy size={14} className="text-gold" />} Copy link
        </DropdownMenuItem>
        <DropdownMenuItem asChild className={itemClass} data-testid={`${testId}-whatsapp`}>
          <a href={`https://wa.me/?text=${encodeURIComponent(message)}`} target="_blank" rel="noreferrer">
            <MessageCircle size={14} className="text-gold" /> WhatsApp
          </a>
        </DropdownMenuItem>
        <DropdownMenuItem asChild className={itemClass} data-testid={`${testId}-email`}>
          <a href={`mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(message)}`}>
            <Mail size={14} className="text-gold" /> Email
          </a>
        </DropdownMenuItem>
        {typeof navigator !== "undefined" && navigator.share && (
          <DropdownMenuItem onSelect={nativeShare} className={itemClass} data-testid={`${testId}-native`}>
            <Link2 size={14} className="text-gold" /> More options
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
